import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Import CSS for react-toastify
import { LOGOUT } from '../auth';

const RESPONSE_SUFFIX = 'RESPONSE';
const ERROR_SUFFIX = 'ERROR';
const DEFAULT_ERROR_MESSAGE = 'Unknown error';
const DEFAULT_ERROR_TITLE = '';
const DEFAULT_ERROR_AUTODISMISS = 4000; // Time in milliseconds

const notificationMiddleware = ({ dispatch }) => next => action => {

  const isError = new RegExp(`${ERROR_SUFFIX}$`, 'g');
  const isResponse = new RegExp(`${RESPONSE_SUFFIX}$`, 'g');

  if (action.type.match(isError) && action.error && !action.error.skipNotification) {
    const title = action.error.title || DEFAULT_ERROR_TITLE;
    const message = action.error.customMessage ||
      (action.error.body && action.error.body.message) || DEFAULT_ERROR_MESSAGE;
    const autoDismiss = action.error.autoDismiss || DEFAULT_ERROR_AUTODISMISS;

    console.error(action);
    
    // Display error notification
    toast.error(
      <>
        <strong>{title}</strong>
        <div>{message}</div>
      </>,
      { autoClose: autoDismiss }
    );

    if (action.error.status === 401) {
      dispatch({ type: LOGOUT });
    }
  } else if (action.type.match(isResponse) && action.response && action.response.notification) {
    const { title, message, level, autoDismiss } = action.response.notification;
    
    // Display notification based on level
    const notify = {
      success: toast.success,
      info: toast.info,
      warning: toast.warn,
      error: toast.error,
    }[level || 'info']; // Default to 'info' if level is not specified

    notify(
      <>
        <strong>{title}</strong>
        <div>{message}</div>
      </>,
      { autoClose: autoDismiss || DEFAULT_ERROR_AUTODISMISS }
    );
  }
  next(action);
};

export {
  notificationMiddleware,
};
